import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { PLACEMENT_STATUS_LABELS } from "../../../constants/automapFeaturedPlacementConstants";
import {
  cancelPlacement,
  createPlacement,
  fetchDealerPlacements,
  pausePlacement,
} from "../../../services/automapFeaturedPlacementApi";
import { AdminPlacementsNav, PlacementForm, toIsoFromLocalInput } from "./AdminPlacementsShared";

const DEFAULT_FORM = {
  placementType: "dealer_directory_featured",
  dealerId: "",
  listingId: "",
  city: "",
  startAtLocal: "",
  endAtLocal: "",
  priority: 50,
  adminOverride: false,
  overrideReason: "",
  force: false,
  notes: "",
};

export default function AdminDealerPlacementsPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [form, setForm] = useState(DEFAULT_FORM);
  const [formError, setFormError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchDealerPlacements();
      setRows(data.placements || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setFormError("");
    try {
      await createPlacement({
        placementType: form.placementType,
        dealerId: form.dealerId,
        city: form.city || null,
        startAt: toIsoFromLocalInput(form.startAtLocal),
        endAt: toIsoFromLocalInput(form.endAtLocal),
        priority: Number(form.priority) || 50,
        adminOverride: form.adminOverride,
        overrideReason: form.overrideReason,
        force: form.force,
        notes: form.notes,
      });
      setForm(DEFAULT_FORM);
      await load();
    } catch (err) {
      setFormError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Destacados" title="Placements de concesionarios" description="Destacar dealers verificados en directorio y home." />
      <AdminAutomotiveNav active="placements" />
      <AdminPlacementsNav active="dealers" />
      <main className="admin-console__main wrap">
        <PlacementForm form={form} onChange={setForm} onSubmit={submit} submitting={submitting} error={formError} />
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading ? (
          <div className="import-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Dealer</th>
                  <th>Ciudad</th>
                  <th>Plan</th>
                  <th>Verificación</th>
                  <th>Slot</th>
                  <th>Estado</th>
                  <th>Inicio</th>
                  <th>Fin</th>
                  <th>Imp.</th>
                  <th>Perfil</th>
                  <th>Leads</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td>{row.dealerName}</td>
                    <td>{row.city || row.dealerCity}</td>
                    <td>{row.planKey}</td>
                    <td>{row.dealerVerified ? "Verificado" : "—"}</td>
                    <td>{row.slotKey}</td>
                    <td>{PLACEMENT_STATUS_LABELS[row.runtimeStatus] || row.runtimeStatus}</td>
                    <td>{row.startAt?.slice(0, 10)}</td>
                    <td>{row.endAt?.slice(0, 10)}</td>
                    <td>{row.performance?.impressions ?? 0}</td>
                    <td>{row.performance?.dealerProfileViews ?? 0}</td>
                    <td>{row.performance?.leads ?? 0}</td>
                    <td>
                      <Link to={`/admin/dealers/${row.dealerId}`}>Dealer</Link>
                      {" · "}
                      <button type="button" onClick={() => pausePlacement(row.id).then(load)}>Pausar</button>
                      {" · "}
                      <button type="button" onClick={() => cancelPlacement(row.id, "Cancelado admin").then(load)}>Cancelar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
